import React, { useEffect } from "react"
import FooterComponent from "../../components/footer"
import ReactHelmet from "src/components/react-helmet"

const ListOnRealtor = () => {
  useEffect(() => {
    try {
      var script = document.createElement("script")
      script.src = "https://paperform.co/__embed"
      script.async = true
      document.body.appendChild(script)
    } catch (error) {
      console.error(error)
    }
  }, [])

  return (
    <>
      <ReactHelmet
        url="list-on-realtor"
        title={`List on Realtor`}
        description="Tolobi - Rental Made Easy"
      />
      <div data-paperform-id="list-on-realtor"></div>
      <FooterComponent />
    </>
  )
}

export default ListOnRealtor
